import { useState } from "react";
import {getUserByUsername} from "../../services/Sysadmin/getUsers";
import {Bounce, toast} from "react-toastify";

interface UserDetails {
    username: string;
    fullName: string;
    role: string;
    state: string;
    email: string;
    mainPhone: string;
    secondaryPhone: string;
}

export const useGetUserDetails = () => {
    const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
    const [isUserDetailsLoading, setIsUserDetailsLoading] = useState(false);

    const fetchUserDetails = async (username: string) => {
        setIsUserDetailsLoading(true);
        try {
            const response:UserDetails  = await getUserByUsername(username);
            setUserDetails(response);
        } catch (error:any) {
            toast.error(error.message, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                transition: Bounce,
            })
            setUserDetails(null);
        } finally {
            setTimeout(() => setIsUserDetailsLoading(false), 600);
        }
    };

    return { userDetails, fetchUserDetails, isUserDetailsLoading, setUserDetails };
};
